import { render, staticRenderFns } from "./SuppliesRequests.vue?vue&type=template&id=3ef15741&"
import script from "./SuppliesRequests.vue?vue&type=script&lang=js&"
export * from "./SuppliesRequests.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesRequests.vue?vue&type=style&index=0&id=3ef15741&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports